export function useProgressiveImage(url: string, initWidth: number | false) {
  const width = initWidth !== false ? initWidth : undefined
  const placeholder = getBlurImage(url, { width, quality: 80 })
  const src = ref(placeholder)

  if (process.client) {
    watchEffect(() => {
      const img = new Image()
      img.src = optimizeImage(url, { width: width ? width * 1.7 : undefined, quality: 90 }) as string
      img.onload = () => {
        src.value = img.src
      }
    })
  }

  const isLoading = computed(() => src.value === placeholder)

  return [src, isLoading] as const
}

export async function getImageSize(url: string): Promise<{ width: number; height: number; url: string }> {
  return new Promise((resolve) => {
    const img = new Image()
    img.onload = () => resolve({ width: img.naturalWidth, height: img.naturalHeight, url })
    img.src = optimizeImage(url, { quality: 1, format: 'webp' }) as string
  })
}

export async function getImagesSizes(urls: string[]) {
  return await Promise.all(urls.map(getImageSize))
}
